import { IService, IServiceBundle } from 'app/interfaces/services';
import { ISpecialist } from 'app/interfaces/specialists';
import { IBranch } from 'app/interfaces/branches';

export function getServiceSubject(item: Pick<IService, 'name'>) {
  return `Запись на услугу ${item.name}`;
}

export function getServiceBundleSubject(item: Pick<IServiceBundle, 'name'>) {
  return `Запись на комплекс ${item.name}`;
}

export function getSpecialistSubject(item: Pick<ISpecialist, 'name'>) {
  return `Запись к специалисту ${item.name}`;
}

export function getBranchSubject(item: Pick<IBranch, 'name'>) {
  return `Запись в студию ${item.name}`;
}

export const defaultSubject = 'Перезвоните мне';
